import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ZonesDetailComponent } from './zones-detail/zones-detail.component';

const routes: Routes = [
  {path:'zones', component:ZonesDetailComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ZonesRoutingModule { }
